import { useQuery } from '@tanstack/react-query';
import { adminFetch } from '@/lib/apiClient';

export interface ProductEventLink {
  targetId: string;
  eventId: string;
  eventKey: string;
  eventTitle: string;
  eventStatus: 'UPCOMING' | 'ONGOING' | 'ENDED';
  startDate: string;
  endDate: string;
  entryMode: 'ORDER' | 'QUANTITY' | 'USER';
  minOrderAmount: number | null;
  minQuantity: number | null;
  isActive: boolean;
  createdAt: string;
}

export const productEventsQueryKey = (productId: string) =>
  ['admin', 'product-events', productId] as const;

export const useProductEventsQuery = (productId: string | undefined) =>
  useQuery<ProductEventLink[]>({
    queryKey: productEventsQueryKey(productId ?? ''),
    enabled: Boolean(productId),
    queryFn: async () => {
      const res = await adminFetch(`/admin/v1/products/${productId}/events`);
      if (!res.ok) throw new Error(`product-events fetch failed: ${res.status}`);
      const env = (await res.json()) as { data?: ProductEventLink[] };
      return Array.isArray(env.data) ? env.data : [];
    },
  });
